'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var dayLabelVariantsStyles = {
    primary: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    font-weight: bold;\n    color: ", ";\n  "], ["\n    font-weight: bold;\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.fontColor;
    }),
    secondary: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    font-weight: 500;\n    color: ", ";\n "], ["\n    font-weight: 500;\n    color: ", ";\n "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }),
    flexUi: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject([""], [""]))),
};
var DayLabel = styled__default.label(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme, size = _a.size;
    return theme.components.calendar.sizes[size].cell.px;
}, function (_a) {
    var theme = _a.theme, size = _a.size;
    return theme.components.calendar.sizes[size].cell.px;
}, function (_a) {
    var variant = _a.variant;
    return dayLabelVariantsStyles[variant];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.DayLabel = DayLabel;
